<template>
  <div :style="{paddingTop :  zoom === 1 ?  '4rem' : '0' }" id="international-call">
    <div class="map-container position-relative">
      <div style="width: 100%; height: 100%" id="holder">
        <Empty v-if="items.length === 0 && !loadCities && !errorCities" />
        <Loader v-if="loadCities" />
        <Error v-if="errorCities" />
        <div v-if="!loadCities && !errorCities" ref="map" id="world-map" class="jvmap-smart"></div>
      </div>
    </div>
    <div  class="header">
      <div v-if="zoom === 1" :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'header-txt my-1']">{{this.$t('internationalCall.title')}}</div>
      <div :class="[this.$lang === 'ar' ? 'right-dir' : '', 'search-bar']">
        <div :style="{background: zoom === 1 ? 'rgba(255,255,255, 0.1)' : 'rgba(255,255,255, 0.6)'}" v-click-outside="handleHide" class="inner-search-bar">
          <div @click="handleShow" class="search-field">
            <img class="search-el" src="../../assets/icons/search-el.svg" />
            <div class="input-container">
              <input id="input-el" v-model="search" :placeholder="placeHolder" type="text" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'mx-1 input-field']" />
            </div>
          </div>
          <img @click="handleShow" class="arrow-icon" src="../../assets/icons/black.svg" />
          <div v-if="show" class="dropdown-animation">
            <div class="custom-dropdown-menu">
              <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'custom-dropdown-item']" v-if="filtered.length === 0">{{ this.$t('empty') }}</div>
              <div @click="handleClick(item)" :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'custom-dropdown-item']" v-for="(item, i) in filtered" :key="i">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fetched" id="holder-el" class="table-container">
      <div v-if="fetched" id="international-table" :style="{bottom: 0}" class="main-content-data">
        <div :class="[this.$lang === 'ar' ? 'right-dir' : '', 'main-content-header']">
          <div class="d-flex align-items-center justify-content-center">
            <span :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'desc']">{{this.$t('internationalCall.servicePrices')}}</span>
            <span :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'country px-4']" id="text">{{ country }}</span>
          </div>
          <div :style="this.$lang === 'ar' ? {left: '10px'} : {right: '10px'}" class="filter-container">
            <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'check-box-container']" >
              <form :class="[this.$lang === 'ar' ? '' : '', 'd-flex h-100 align-items-center']">
                <div v-if="width > 1100"  style="font-size: 12px" :class="this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{$t('popularBundles.showResults')}}</div>
                <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'check d-flex align-items-center justify-center px-5']">
                  <input class="d-none" type="radio" v-model="checked" id="pre" name="filter" value="0">
                  <div @click="checked = 0" class="checkbox-element">
                    <div v-if="checked == 0" class="checked position-relative">
                      <div class="black-shadow"></div>
                    </div>
                  </div>
                  <label :class="[this.$lang === 'ar' && checked == 0 ? 'bold-italic-ar' : checked == 0 ? 'bold-italic-en' : '', 'px-2']" for="pre">{{this.$t('internationalCall.line.pre')}}</label>
                </div>
                <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'check d-flex align-items-center justify-center']">
                  <input class="d-none" type="radio" id="post" v-model="checked" name="filter" value="1">
                  <div @click="checked = 1" class="checkbox-element">
                    <div v-if="checked == 1" class="checked position-relative">
                      <div class="black-shadow"></div>
                    </div>
                  </div>
                  <label :class="[this.$lang === 'ar' && checked == 1 ? 'bold-italic-ar' : checked == 1 ? 'bold-italic-en' : '', 'px-2']" for="post">{{this.$t('internationalCall.line.post')}}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 20px 0">
        <div :style="{border: load ? 'none' : '2px solid rgba(106,106,106,.8)'}" :class="[this.$lang === 'ar' ? 'right-dir' : '', 'custom-table']">
          <div v-if="load" class="response-handle">
            <Loader />
          </div>
          <div v-if="error" style="height: 120px; width: 100%; display: flex; align-items: center; justify-content: center">{{message}}</div>
          <div v-if="!load && !error && table.length === 0" style="height: 120px; width: 100%; display: flex; align-items: center; justify-content: center" :class="lang === 'ar' ? 'regular-ar' : 'regular-en'">{{ $t('internationalCall.msg') }}</div>
          <div v-if="table.length" :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'table-header']">
            <div :style="{width: `calc(100% / ${table.length})`}" v-for="(column, i) in table" :class="[lang === 'ar' ? 'border-ar' : 'border-en', 'table-item']" :key="i">
              <div :class="lang === 'ar' ? 'right-dir bold-italic-ar' : 'right-dir bold-italic-en'">
                <div>{{ column.title }}</div>
                <div :class="lang === 'ar' ? 'right-dir' : 'left-dir'" v-if="i !== 0">{{ column.time }}</div>
              </div>
            </div>
          </div>
          <div v-if="table.length" :class="[this.$lang === 'ar' ? '' : '', 'table-body']">
            <div :style="{width: `calc(100% / ${table.length})`}" v-for="(column, i) in table" :class="[lang === 'ar' ? 'border-ar' : 'border-en', 'table-item']" :key="i">{{ column.cost }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InternationalCallsRepository from '../../repositories/InternationalCallsRepository'
import RoamingCitiesRepository from '../../repositories/RoamingCitiesRepository'
import Loader from '../../components/LoaderBtn/Loader.vue'
import Error from '../../components/errorHandle/Error'
import Empty from '../../components/emptyData/Empty'
// import Error from '../../components/errorHandle/Error.vue'

window.jQuery = require('jquery')
const $ = window.jQuery
require('jvectormap')
require('../../lib/jquery-jvectormap-world-mill-en.js')
require('../../lib/jquery-jvectormap-world-mill-ar.js')
require('../../lib/jquery-jvectormap.css')
export default {
  components: { Error, Loader, Empty },
  data () {
    return {
      show: false,
      nav: true,
      search: '',
      items: [],
      filtered: [],
      country: '',
      selectedCode: '',
      selectedCountry: '',
      zoom: 1,
      table: [],
      placeHolder: this.$lang === 'ar' ? 'أدخل اسم البلد...' : 'Enter Country Name...',
      checked: 0,
      width: this.$store.state.window,
      lang: this.$lang,
      callsRepo: new InternationalCallsRepository(),
      citiesRepo: new RoamingCitiesRepository(),
      load: false,
      error: false,
      validCodes: [],
      loadCities: false,
      errorCities: false,
      draw: false,
      fetched: false,
      message: '',
      mapObj: null
    }
  },
  watch: {
    checked (val) {
      this.fetchData(this.selectedCountry.code, val)
    },
    search (val) {
      this.filtered = [...this.items]
      if (val) {
        this.filtered = this.filtered.filter((item) => {
          return item.name.toLowerCase().includes(val.toLowerCase())
        })
      } else {
        this.filtered = [...this.items]
      }
    },
    fetched (val) {
      setTimeout(() => {
        if (val) {
          this.drawMap(this.selectedCountry)
          this.handleSize()
        }
      }, 50)
    }
  },
  mounted () {
    this.fetchCities()
    this.handleSize()
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      this.width = val
      if (this.$store.state.tab === 4) {
        this.handleSize()
      }
    })
    this.$watch(() => {
      return this.$store.state.tab
    }, val => {
      if (val !== 4) {
        this.removeMap()
      } else {
        setTimeout(() => {
          this.drawMap(this.selectedCountry)
        })
      }
    })
  },
  beforeDestroy () {
    if (this.draw) {
      this.removeMap()
    }
  },
  methods: {
    handleClick (item) {
      const oldCode = this.selectedCode
      const map = $('#world-map').vectorMap('get', 'mapObject')
      this.handleHide()
      this.search = item.name
      this.country = item.name
      this.selectedCountry = item
      this.selectedCode = item.code
      this.fetchData(item.code, this.checked)
      map.setSelectedRegions({ [oldCode]: false })
      map.setSelectedRegions({ [item.code]: true })
      this.$forceUpdate()
    },
    handleShow () {
      this.show = true
      document.getElementById('input-el').focus()
      $('.arrow-icon').addClass('rotate')
      setTimeout(() => {
        $('.custom-dropdown-menu').addClass('showed')
      })
    },
    handleHide () {
      $('.arrow-icon').removeClass('rotate')
      $('.custom-dropdown-menu').removeClass('showed')
      setTimeout(() => {
        this.show = false
      }, 300)
    },
    removeMap () {
      this.mapObj.remove()
    },
    drawMap (country) {
      const temp = this
      $('#world-map').vectorMap({
        map: `world_mill_${temp.$lang === 'ar' ? 'ar' : 'en'}`,
        regionsSelectable: true,
        regionsSelectableOne: true,
        zoomOnScroll: false,
        backgroundColor: 'transparent',
        zoom: 3,
        regionStyle: {
          initial: {
            fill: 'rgb(255,203,5,0.3)',
            'fill-opacity': 1,
            stroke: 'rgb(255,203,5,1)',
            'stroke-width': 0.5,
            'stroke-opacity': 1
          },
          hover: {
            fill: '#FFBD00',
            cursor: 'pointer'
          },
          selected: {
            fill: '#FFCB05'
          }
        },
        selectedRegions: country.code,
        onViewportChange: function (e, scale) {
          temp.zoom = scale
        },
        onRegionClick: function (e, code) {
          const lang = temp.$lang === 'ar' ? 'ar' : 'en'
          const regionNames = new Intl.DisplayNames(
            [lang], { type: 'region' }
          )
          temp.selectedCode = code
          for (let i = 0; i < temp.items.length; i++) {
            if (temp.items[i].code === code) {
              temp.fetchData(code, temp.checked)
            } else {
              // console.log('sss')
            }
          }
          if (code === 'IL') {
            temp.country = temp.$lang === 'ar' ? 'فلسطين' : 'Palestine'
          } else if (code === 'NCY') {
            temp.country = temp.$lang === 'ar' ? 'شمال قبرص' : 'North Cyprus'
          } else if (code === 'SOL') {
            temp.country = temp.$lang === 'ar' ? 'صوماليلاند' : 'Somaliland'
          } else {
            temp.country = regionNames.of(code)
          }
          temp.selectedCountry.code = code
          temp.selectedCountry.name = temp.country
        }
      })
      this.draw = true
      this.mapObj = $(this.$refs.map).vectorMap('get', 'mapObject')
      // this.fetchData(this.items[0].code, this.checked)
      this.arabic()
    },
    handleSize () {
      if (this.draw) {
        if (this.$store.state.window < 750) {
          $('#world-map').vectorMap('get', 'mapObject').setFocus({
            lat: 30,
            lng: 70,
            scale: 2.5
          })
        } else {
          $('#world-map').vectorMap('get', 'mapObject').setFocus({
            lat: 5,
            lng: 5,
            scale: 1
          })
        }
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.jvectormap-zoomout').css('right', 'unset')
        $('.jvectormap-zoomin').css('right', 'unset')
        $('.jvectormap-zoomout').css('left', 'calc(4vw + 55px)')
        $('.jvectormap-zoomin').css('left', '4vw')
      }
    },
    async fetchData (code, line) {
      const temp = []
      this.table = []
      this.load = true
      try {
        const response = await this.callsRepo.getExtra(code, line)
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            temp.push({
              title: response.data[i].title,
              time: `${response.data[i].startTime} - ${response.data[i].endTime}`,
              cost: response.data[i].cost
            })
          }
        } else {
          this.message = response.message
          this.error = true
        }
      } catch (e) {
        console.log(e)
      } finally {
        if (code === this.selectedCode) {
          this.table = [...temp]
        }
      }
      this.load = false
    },
    async fetchCities () {
      this.loadCities = true
      this.items = []
      try {
        const response = await this.citiesRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.items.push({ name: response.data[i].name, code: response.data[i].code })
            this.validCodes.push(response.data[i].code)
          }
          this.filtered = [...this.items]
          if (this.items.length) {
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].code === 'LB') {
                this.firstFetch(this.items[i])
                return
              }
            }
          } else {
          }
        } else {
          this.errorCities = true
        }
      } catch (e) {
        this.errorCities = true
      }
      this.loadCities = false
    },
    async firstFetch (country) {
      this.table = []
      this.loadCities = true
      try {
        const response = await this.callsRepo.getExtra(country.code, this.checked)
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.table.push({ title: response.data[i].title, time: `${response.data[i].startTime} - ${response.data[i].endTime}`, cost: response.data[i].cost })
          }
          this.fetched = true
          this.country = country.name
          this.selectedCountry = country
          this.selectedCode = country.code
        } else {
          this.errorCities = true
        }
      } catch (e) {
        this.errorCities = true
      }
      this.loadCities = false
    }
  }
}
</script>
<style lang="scss" scoped>
/*@import "src/assets/sass/main";*/
#international-call {
  min-height: calc(100vh - (155px + 285.6px));
}
.filter-container{
  width: max-content;
  position: absolute;
}
.check-box-container{
  padding: 0 4vw;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%
}
.check{
  cursor: pointer;
  label{
    font-size: 11px;
  }
}
.checkbox-element{
  height: 18px;
  width: 18px;
  border: 2px solid #FFCB05;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checked{
  height: 10px;
  width: 10px;
  background: #FFCB05;
  border-radius: 50%;
}
.black-shadow {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  position: absolute;
  z-index: -1;
  background: rgba(0,0,0,.5);
  filter: blur(4px);
  bottom: -1px;
  right: -1px;
}
.check label {
  cursor: pointer;
}
.border-en{
  border-right: 2px solid #6a6a6a;
}
.border-ar{
  border-left: 2px solid #6a6a6a;
}
.border-en:last-child,
.border-ar:last-child{
  border-right: none !important;
  border-left: none !important;
}
.rotate{
  transform: rotate(180deg);
}
#international-call{
  background: #f2f2f2;
  padding: 0rem 0 0px  0;
  position: relative;
}
.map-container{
  height: 580px
}
@media screen and (max-width: 750px) {
  .map-container{
    height: 380px!important;
  }
}
.header{
  position: absolute;
  top: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.search-bar {
  height: 48px;
  width: 25%;
  border: 3px solid #FFCB05;
  border-radius: 15px;
}
.inner-search-bar{
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: pointer;
}
.input-container{
  padding-top: 2px;
  width: 95%
}
.search-field{
  width: 100%;
  text-align: initial;
  display: flex;
  align-items: center;
}
.search-el{
  height: 25px
}
.arrow-icon{
  width: 9px;
  transition: transform .3s ease-in-out;
}
.input-field{
  width: 100%;
}
.input-field:focus{
  outline: none
}
.input-field::placeholder{
  color: black !important;
  opacity: 1 !important;
  font-size: 12px !important;
  padding: 3px 15px 0 15px !important;
}
.custom-dropdown-menu{
  width: 100%;
  background: rgba(255,255,255, 1);
  //backdrop-filter: blur(25px);
  position: absolute;
  left: 0;
  top: 48px;
  border-radius: 10px;
  border: 1.5px solid rgba(255, 255, 255, 0.7);
  opacity: 0;
  transition: opacity .3s ease-in-out;
  max-height: 315px;
  overflow-y: auto;
}
.custom-dropdown-item{
  margin: 0 20px;
  padding: 1rem 0;
  border-bottom: 2px solid  #FFCB05;
}
.custom-dropdown-item:last-child{
  border: none
}
.showed{
  opacity: 1;
}
.header-txt{
  font-size: 18px;
  color: #FFCB05;
}
.table-container {
  background: linear-gradient(180deg, rgba(242,242,242,.5), rgba(255,255,255,.5));
  backdrop-filter: blur(30px);
  min-height: calc(100vh - (110px + 600px + 285.5px));
  box-shadow: 0 -15px 40px rgba(0,0,0,0.05);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-top: 3px solid rgba(255,255,255,.2);
  margin-top: -30px
}
.main-content-data{
  background:  transparent;
  width: 100%;
  height: 220px;
  padding: 0 0 0 .5rem;
  height: auto;
}
.main-content-header{
  position: relative;
  height: 60px;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0rem 0 0rem 0 //  margin: 0rem 0 1.8rem 0
}
.custom-placeholder{
  position: absolute;
  font-size: 12px;
  padding: 4px 15px 0 15px
}
.desc{
  color: #FFCB05;
  font-style: italic;
  font-size: 17px
}
.country{
  font-size: 17px
}
.custom-table{
  width: calc(100% - 8vw);
  min-height: 120px;
  margin: 0 auto;
  border-radius: 30px;
}
.response-handle{
  height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-header{
  display: flex;
  .table-item{
    color: #FFCB05;
    border-bottom: 2px solid rgba(106,106,106,.8);
    padding: 10px;
  }
}
.table-item{
  //width: 33.33%;
  //width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  font-size: 13px;
  word-break: break-word;
}
.table-body{
  min-height: 60px;
  display: flex;
}

/*-------------------------- responsive ----------------------*/
@media (max-width: 1400px) {
  .search-bar {
    width: 30%;
  }
}
@media (max-width: 1200px) {
  .search-bar {
    width: 35%;
  }
}
@media (max-width: 1000px) {
  .search-bar {
    width: 40%;
  }
}
@media (max-width: 850px) {
  .main-content-header{
    display: block;
    margin: 1rem 0
  }
  .filter-container{
    position: unset;
    margin: 10px auto 0 auto;
  }
  .search-bar {
    width: 45%;
  }
}
@media (max-width: 750px) {
  .search-bar {
    width: 50%;
  }
  .header-txt{
    font-size: 16px;
  }
  .search-el{
    height: 20px
  }
}
@media (max-width: 650px) {
  .search-bar {
    width: 60%;
  }
}
@media (max-width: 550px) {
  .search-bar {
    width: 65%;
  }
  .main-content-data{
    padding: 1rem 0 .7rem 0;
  }
}
@media (max-width: 500px) {
  .search-bar {
    width: 75%;
  }
}
@media (max-width: 480px) {
  .search-bar {
    width: 85%;
  }
  .header-txt{
    font-size: 15px
  }
  .desc,.country{
    font-size: 16px
  }
  .table-item{
    font-size: 12px;
    height: 75px;
    padding: 0 2px
  }
  .main-fake-container{
    min-height: calc(100vh - (400px + 160px + 285px));
  }
}
/*------------------ responsive table ------------------------*/
@media( max-width: 1100px) {
  .main-content-data{
    //bottom: -446px
  }
  .custom-table{
    display: flex;
  }
  .table-header,
  .table-body{
    display: block;
    width: 50%
  }
  .table-item{
    width: 100% !important;
  }
  .table-body > .table-item {
    border-bottom: 2px solid rgba(106,106,106,.8);
  }
  .table-item:last-child{
    border: none !important;
  }
  .table-body {
    .border-ar,
    .border-en {
      border-right: none;
      border-left: none
    }
  }
  .border-en:last-child{
    border-right: 2px solid rgba(106,106,106,.8) !important;
  }
  .border-ar:last-child{
    border-left: 2px solid rgba(106,106,106,.8) !important;
  }
  .table-body {
    .border-en:last-child{
      border-right: none !important;
    }
    .border-ar:last-child{
      border-left: none !important;
    }
  }
}
/*------------------------------------------------------------*/
/*------------------------------------------------------------*/
</style>
<style lang="scss">
@import "src/assets/sass/main";
div#world-map,
.jvectormap-container,
svg{
  height: 100%;
  width:100%
}
.jvectormap-zoomin,
.jvectormap-zoomout{
  top: unset !important;
  bottom: 50px; //from 0 to 50
  height: 30px;
  width: 30px;
  border: 3px solid $--yellow;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(29,29,29);
  font-size: 18px
}
.jvectormap-zoomout{
  left: unset;
  right: calc(4vw + 55px)
}
.jvectormap-zoomin{
  left: unset;
  right: 4vw
}
path.jvectormap-region:hover{
  transform: scale(1.005);
  transition: transform .3s ease-in-out;
  background: #FFBD00
}
.jvectormap-tip {
  font-family: Mtn-arabic-regular;
  color: #1d1d1d;
  background: $--gray-gradient;
  border: none
}
/*-------- responsive ----------*/
@media (max-width: 480px) {
  #international-call{
    padding: 0!important;
  }
  .map-container,
  div#world-map,
  .jvectormap-container,
  svg{
    height: 100%;
  }

}
/*------------------------------*/
</style>
